import React, { useState } from 'react';
import { Zap, ChevronDown, Check, Loader2 } from 'lucide-react';
import { getBatchSteps } from '../../config/build-checklist';

const BuildBatchBar = ({ selectedBuildIds, password, onDone }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(null); // step_id of in-progress batch

  const batchSteps = getBatchSteps();
  const hasSelection = selectedBuildIds.length > 0;

  const runBatch = async (stepId) => {
    if (!hasSelection) return;
    setLoading(stepId);
    try {
      const res = await fetch('/api/batch-complete-step', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-admin-password': password },
        body: JSON.stringify({ step_id: stepId, build_package_ids: selectedBuildIds, action: 'done' }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Batch failed');
      onDone(stepId, data);
    } catch (err) {
      console.error(err);
      alert(`Batch error: ${err.message}`);
    } finally {
      setLoading(null);
    }
  };

  if (!hasSelection) return null;

  return (
    <div className="sticky top-0 z-20 bg-[#0A0A14] border-b border-[#F0EFF4]/10 px-4 py-2 flex items-center gap-3">
      <div className="flex items-center gap-1.5">
        <Zap className="w-4 h-4 text-[#7B61FF]" />
        <span className="text-sm font-bold text-[#F0EFF4] font-data">
          {selectedBuildIds.length} build{selectedBuildIds.length > 1 ? 's' : ''} selected
        </span>
      </div>

      <div className="relative">
        <button
          onClick={() => setOpen(v => !v)}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-[#7B61FF] hover:bg-[#6B51EF] text-white text-xs font-bold rounded-lg transition-colors"
        >
          Batch Complete Step
          <ChevronDown className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`} />
        </button>

        {open && (
          <div className="absolute top-full left-0 mt-1 w-72 bg-[#18181B] border border-[#F0EFF4]/10 rounded-xl shadow-xl z-30 overflow-hidden">
            <div className="p-2 border-b border-[#F0EFF4]/10">
              <span className="text-[11px] font-data text-[#F0EFF4]/40 uppercase tracking-wider">Batch-eligible steps</span>
            </div>
            <div className="max-h-64 overflow-y-auto">
              {batchSteps.map(step => (
                <button
                  key={step.id}
                  onClick={() => { runBatch(step.id); setOpen(false); }}
                  disabled={loading === step.id}
                  className="w-full text-left px-3 py-2 text-sm text-[#F0EFF4]/80 hover:bg-[#F0EFF4]/5 hover:text-[#F0EFF4] flex items-center gap-2 transition-colors"
                >
                  {loading === step.id
                    ? <Loader2 className="w-3 h-3 animate-spin text-[#7B61FF] shrink-0" />
                    : <Check className="w-3 h-3 text-[#F0EFF4]/20 shrink-0" />
                  }
                  <span className="truncate">{step.label}</span>
                  <span className="ml-auto text-[10px] font-data text-[#F0EFF4]/20 shrink-0">{step.id}</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BuildBatchBar;
